import { lazy } from 'react';

const Login = lazy(() => import('../../account/Login'));
const Signup = lazy(() => import('../../account/Signup'));
const Activate = lazy(() => import('../../account/Activate'));
const ResetPassword = lazy(() => import('../../account/ResetPassword'));
const ResetPasswordConfirm = lazy(() => import('../../account/ResetPasswordConfirm'));
const AccountSettings = lazy(() => import('../../pages/Account/Settings'));
const AuthGateway = lazy(() => import('../../pages/Auth/AuthGateway'));

export const authPublicRoutes = [
  { path: '/auth/start', element: <AuthGateway /> },
  { path: '/login', element: <Login /> },
  { path: '/signup', element: <Signup /> },
  { path: '/reset-password', element: <ResetPassword /> },
  { path: '/password/reset/confirm/:uid/:token', element: <ResetPasswordConfirm /> },
  { path: '/activate/:uid/:token', element: <Activate /> },
];

export const authProtectedRoutes = [
  { path: '/account/settings', element: <AccountSettings /> },
];
